export default __webpack_public_path__ + "static/ozgur-39fcc901ec3fe2284775f44a2b0d4f94.jpg";